module.exports = __webpack_public_path__ + "img/signup-ellipse.c726fdec.png";